export default __webpack_public_path__ + "static/link-item-do-4cbe29f13ccc97bc59282030b9e05985.png";